/*
 Created by CHT 2019/9/17 16:33
 多行文本
 */

import SingleLine from "./SingleLine"
import {
	FORM_ITEM__MULTILINE
} from "../types"

class Multiline extends SingleLine {

	constructor() {
		super()

		// 校验条件
		this.checkCondition = {
			checkType: "TEXT",
			lengthLimit: 0, 			// 开启长度限制 0 否 1 是
			minLength: 5, 				// 最短
			maxLength: 100, 				// 最长
			regexLimit: 0, 				// 开启正则校验
			regexStr: "", 					// 内置 手机 邮箱 正则 可以自定义
			matchId: ''           // 正则的 ID
		}
	}

	get title() {
		return this.fieldTitle || Multiline._title
	}

	 set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

Multiline._title = '多行文本'
Multiline.type = FORM_ITEM__MULTILINE
Multiline.use = true
Multiline.icon = 'iconfont icon-duohangwenben'

Multiline.prototype.type = Multiline.type

export default Multiline
